import { ENODEV } from "constants";
import { environment } from "src/environments/environment";

export enum EndPoint {
  LOCAL = 'api/localTrabalho',
  ADMINUSER = 'api/adminUser',
  EMPRESA = 'api/empresa',
  COLABORADOR = 'api/colaborador',
  IMAGEMPERFIL = 'api/imagem-perfil',
  COLABORADOR_V2 = 'api/v2/colaborador',
  ESCALA = 'api/v2/escala',
  LOGIN = 'api/public/login',
  NEW_LOGIN = 'api/public/newUser',
  ESCALA_PERIODO = 'api/v2/escala-periodo',
  ESCALA_PERIODO_SETOR_GET = 'api/v2/escala-periodo/{escalaPeriodoId}/setores',
  ESCALA_PERIODO_TURNO_GET = 'api/v2/escala-periodo/{escalaPeriodoId}/turnos',

  ESCALA_PERIODO_SETOR = 'api/v2/escala-periodo/setores',
  ESCALA_PERIODO_TURNO = 'api/v2/escala-periodo/turnos',

  ESCALA_PERIODO_COLABORADORES = 'api/v2/escala-periodo/colaboradores',
  ESCALA_PERIODO_COLABORADOR = 'api/v2/escala-colaborador',
  ITEM_COLABORADOR = 'api/v2/escala-colaborador/itens',

  RECUPERAR_SENHA = 'api/public/recovery',
  SOLICITACAO_TROCA = 'api/solicitacao-troca'
}

function getRootEndpoint() {
  return environment.api;
  //return (document.URL.indexOf("http://localhost:81") == 0 ? environment.proxy : environment.api) + "";
}

export function getEndpoint(endpoint: EndPoint): string {
  switch(endpoint) {
    case EndPoint.LOCAL:
      return `${getRootEndpoint()}${EndPoint.LOCAL}`
    case EndPoint.ADMINUSER:
      return `${getRootEndpoint()}${EndPoint.ADMINUSER}`
    case EndPoint.EMPRESA:
      return `${getRootEndpoint()}${EndPoint.EMPRESA}`
    case EndPoint.COLABORADOR:
      return `${getRootEndpoint()}${EndPoint.COLABORADOR}`
    case EndPoint.COLABORADOR_V2:
      return `${getRootEndpoint()}${EndPoint.COLABORADOR_V2}`
    case EndPoint.IMAGEMPERFIL:
      return `${getRootEndpoint()}${EndPoint.IMAGEMPERFIL}`
    case EndPoint.ESCALA:
      return `${getRootEndpoint()}${EndPoint.ESCALA}`
    case EndPoint.LOGIN:
      return `${getRootEndpoint()}${EndPoint.LOGIN}`
    case EndPoint.NEW_LOGIN:
      return `${getRootEndpoint()}${EndPoint.NEW_LOGIN}`
    case EndPoint.ESCALA_PERIODO:
      return `${getRootEndpoint()}${EndPoint.ESCALA_PERIODO}`
    case EndPoint.ESCALA_PERIODO_TURNO:
      return `${getRootEndpoint()}${EndPoint.ESCALA_PERIODO_TURNO}`
    case EndPoint.ESCALA_PERIODO_SETOR:
      return `${getRootEndpoint()}${EndPoint.ESCALA_PERIODO_SETOR}`
    case EndPoint.ESCALA_PERIODO_TURNO_GET:
      return `${getRootEndpoint()}${EndPoint.ESCALA_PERIODO_TURNO_GET}`
    case EndPoint.ESCALA_PERIODO_SETOR_GET:
      return `${getRootEndpoint()}${EndPoint.ESCALA_PERIODO_SETOR_GET}`
    case EndPoint.ITEM_COLABORADOR:
      return `${getRootEndpoint()}${EndPoint.ITEM_COLABORADOR}`
    case EndPoint.RECUPERAR_SENHA:
      return `${getRootEndpoint()}${EndPoint.RECUPERAR_SENHA}`
    case EndPoint.SOLICITACAO_TROCA:
      return `${getRootEndpoint()}${EndPoint.SOLICITACAO_TROCA}`
    case EndPoint.ESCALA_PERIODO_COLABORADORES:
      return `${getRootEndpoint()}${EndPoint.ESCALA_PERIODO_COLABORADORES}`
    case EndPoint.ESCALA_PERIODO_COLABORADOR:
      return `${getRootEndpoint()}${EndPoint.ESCALA_PERIODO_COLABORADOR}`
    default:
      return '';
  }
}
